import React from 'react';
import { FormControl, Select, MenuItem, InputLabel } from '@mui/material';
import type { FlatExecuteStep } from '@/types/run-stage.types';

interface GoToStepDropdownProps {
  flatSteps: FlatExecuteStep[];
  currentIndex: number;
  onSelect: (index: number) => void;
}

export const GoToStepDropdown: React.FC<GoToStepDropdownProps> = ({
  flatSteps,
  currentIndex,
  onSelect,
}) => {
  return (
    <FormControl size="small" sx={{ minWidth: 200 }}>
      <InputLabel sx={{ fontSize: '0.8rem' }}>Go to step</InputLabel>
      <Select
        value={currentIndex}
        onChange={(e) => onSelect(Number(e.target.value))}
        label="Go to step"
        sx={{ fontSize: '0.8rem' }}
      >
        {flatSteps.map((fs, idx) => (
          <MenuItem key={`${fs.step.stepId}-${fs.step.cloneNumber ?? 0}-${idx}`} value={idx}>
            {fs.displayName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
